import { defineAgenda, param } from '@/shared/navigation/core';

/**
 * Agenda detailu termínového seriálu. Otevírá se výběrem uzlu seriálu ve stromu (potřebuje productId i serieId,
 * aby odpovídala backendovému kontraktu `/products/{productId}/series/{serieId}`).
 */
export const serieDetailAgenda = defineAgenda({
  id: 'app.planner.serie-detail',
  path: 'app/planner/serie-detail',
  open: {
    productId: param.uuid(),
    serieId: param.uuid(),
  },
  title: 'Detail seriálu',
  icon: 'layers',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
